import React, { useRef } from 'react';
import { useEditorStore } from '../hooks/useEditorStore';
import { uploadModel } from '../services/api';
import styles from './FileUpload.module.css';

export default function FileUpload() {
  const fileInputRef = useRef(null);
  const { setUploadedFile, setLoading, setError, setSuccess } = useEditorStore();

  const handleFileSelect = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // Validate file type
    const validTypes = ['.glb', '.gltf', '.obj'];
    const fileName = file.name.toLowerCase();
    const isValidType = validTypes.some((type) => fileName.endsWith(type));

    if (!isValidType) {
      setError('Invalid file type. Please upload GLB, GLTF, or OBJ files.');
      return;
    }

    if (file.size > 500 * 1024 * 1024) {
      setError('File size exceeds 500MB limit');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const result = await uploadModel(file);

      // Store both the original file and the backend filename
      setUploadedFile(file, result.filename, result.sessionId);
      setSuccess(`Model uploaded: ${file.name}`);

      // Reset file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <label className={styles.uploadLabel}>
        <input
          ref={fileInputRef}
          type="file"
          onChange={handleFileSelect}
          accept=".glb,.gltf,.obj"
          className={styles.input}
        />
        <div className={styles.button}>
          <span>📁 Upload 3D Model</span>
          <p className={styles.hint}>GLB, GLTF, or OBJ (max 500MB)</p>
        </div>
      </label>
    </div>
  );
}
